module.exports = __webpack_public_path__ + "static/image4-88069e645ec00df854d8f0b7b8869b56.jpeg";